import { Box, Button, HStack, Icon, Text, } from "@chakra-ui/react";
import { ChevronLeftIcon, } from "@heroicons/react/24/solid";
import { Link as RouterLink, useParams, } from "react-router-dom";
import { useQuery, } from "@tanstack/react-query";
import { limitByIdQueryConfig, } from "../../../../api";
import { RoutesMap, } from "../../../../routes.tsx";

export function LimitPageHeader() {
  const limitId = useParams().id!;
  const { data, } = useQuery(limitByIdQueryConfig(limitId,),);

  return (
    <HStack alignItems="center" spacing={4}>
      <Box>
        <Button as={RouterLink} to={RoutesMap.index} variant="circle" mb={2}>
          <Icon as={ChevronLeftIcon} boxSize={6} />
        </Button>
      </Box>
      <Box flex={1}>
        {!!data && (
          <Text align="center">
            {data.name}
          </Text>
        )}
      </Box>
      <Box boxSize={12} />
    </HStack>
  );
}
